var map = {
	"./browser-notice.de-CH.json": 954,
	"./browser-notice.de-DE.json": 955,
	"./browser-notice.en-CA.json": 956,
	"./browser-notice.en-GB.json": 957,
	"./browser-notice.en-IN.json": 958,
	"./browser-notice.en-ME.json": 959,
	"./browser-notice.en-US.json": 960,
	"./browser-notice.es-EM.json": 961,
	"./browser-notice.es-ES.json": 962,
	"./browser-notice.fr-BE.json": 963,
	"./browser-notice.fr-CA.json": 964,
	"./browser-notice.fr-CH.json": 965,
	"./browser-notice.nl-BE.json": 966,
	"./browser-notice.nl-NL.json": 967,
	"./browser-notice.pl-PL.json": 968,
	"./browser-notice.pt-BR.json": 969
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 953;